import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const faqs = [
  {
    question: "What areas do you service?",
    answer: "We primarily service Jersey City and Hoboken, New Jersey. This includes Downtown JC, The Heights, Journal Square, Bergen-Lafayette, and all neighborhoods within Hoboken. We also cover some nearby surrounding areas in Hudson County."
  },
  {
    question: "Do I need to be home during the cleaning?",
    answer: "No, you don't need to be home. Many of our clients provide us with a key or entry code. We are fully insured and background-checked, so you can have peace of mind knowing your home is in safe hands."
  },
  {
    question: "What cleaning supplies do you use?",
    answer: "We bring all of our own professional-grade cleaning supplies and equipment. We use high-quality, effective products that are safe for your home. We also offer eco-friendly/green cleaning options upon request."
  },
  {
    question: "How long does a cleaning take?",
    answer: "The duration depends on the size of your home and the type of service requested. A standard cleaning for a 1-bedroom apartment typically takes 2-3 hours, while a deep cleaning or a larger home will take longer. We'll give you a more accurate estimate when you book."
  },
  {
    question: "Do you offer recurring cleaning discounts?",
    answer: "Yes! We offer significant discounts for recurring services. Weekly clients save the most, followed by bi-weekly and monthly schedules. It's the best way to keep your home consistently clean while saving money."
  },
  {
    question: "What is your pet policy?",
    answer: "We love pets! To keep our staff safe and ensure we can complete your cleaning without interruption, we ask that dogs and cats be secured in a closed room or crate during the visit — or that you're present to manage them as we move through the home. This helps us cover every area fully and efficiently. Please note that for liability reasons, our team is unable to move or handle pets during service."
  }
];

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-5xl font-extrabold text-brand-navy mb-6">
            Frequently Asked <span className="text-brand-blue">Questions</span>
          </h2>
          <p className="text-lg text-brand-navy/70">
            Everything you need to know about our professional cleaning services.
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className={`border rounded-3xl transition-all duration-300 ${
                openIndex === index ? 'border-brand-blue bg-brand-blue/5 shadow-lg' : 'border-gray-100 bg-brand-gray-50'
              }`}
            >
              <button
                className="w-full px-8 py-6 flex items-center justify-between text-left"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="text-lg font-bold text-brand-navy">{faq.question}</span>
                {openIndex === index ? (
                  <ChevronUp className="w-5 h-5 text-brand-blue" />
                ) : (
                  <ChevronDown className="w-5 h-5 text-brand-navy/40" />
                )}
              </button>
              
              {openIndex === index && (
                <div className="px-8 pb-8 animate-in fade-in slide-in-from-top-2 duration-300">
                  <p className="text-brand-navy/70 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
